import { useState, useRef, useCallback, useEffect } from "react";
import { Select, Form, Table, Spin, Input, Button, DatePicker, Checkbox } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import csv from "../../assets/images/csv.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { useDownloadExcel } from "react-export-table-to-excel";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import Loader from "react-spinners/BarLoader";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import "../ProducList/productList.css";
import { getRegion } from "../../redux/actions/region.action";
import { getStyle } from "../../redux/actions/style";
import { getGender } from "../../redux/actions/gender.action";
import { getWashName } from "../../redux/actions/wash.action";
import { getInseam } from "../../redux/actions/inseam.action";
import { getCut } from "../../redux/actions/cut.action";
import { getShippedStyleWisePercentageReport } from "../../redux/actions/wiseStockReport.action";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const { Option } = Select;
const ShippedStyleWisePercentage2 = ({ token }) => {
  TabTitle("Shipped-Style-Wise-Percentage");
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const company_id = ReadCookie("defaultCompany");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { saleOrderFormData, OmsReprot, sizeCurve, region, style, cut, gender, inseam } = useSelector(
    (state) => state
  );
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const tableRef = useRef(null);
  const [filters, setFilters] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [allFilters, setAllFilters] = useState([
    { id: 1, name: "Shipped", selected: false },
    { id: 2, name: "Return", selected: false },
    { id: 3, name: "POD", selected: false },
    { id: 4, name: "Pending", selected: false },
  ]);
  const [ptfilters, setPtFilters] = useState([]);
  const [ptAllStatus, setPtAllStatus] = useState(true);
  const [ptAllFilters, setPtAllFilters] = useState([
    { id: 2, name: "Majors", selected: false },
    { id: 14, name: "Dropship", selected: false },
    { id: 1, name: "Specialty", selected: false },
    { id: 3, name: "ECOM", selected: false },
    { id: 13, name: "INT", selected: false },
  ]);

  //   const ProductionFilters = {
  //   filter1: values.filter1,
  //   filter2: values.filter2,
  //   // Add more filters here as needed
  // };

  // const queryParams = new URLSearchParams(ProductionFilters).toString();

  const statusSelectAll = (e) => {
    let copyArr = [...allFilters];
    copyArr.map((v) => {
      v.selected = false;;
      return v;
    });
    setAllFilters(copyArr);
    setAllStatus(e.target.checked);
  };

  useEffect(() => {
    if (allStatus) {
      setFilters([]);
    }
  }, [allStatus])

  const statusPTSelectAll = (e) => {
    let copyArr = [...ptAllFilters];
    copyArr.map((v) => {
      v.selected = false;;
      return v;
    });
    setPtAllFilters(copyArr);
    setPtAllStatus(e.target.checked);
  };

  useEffect(() => {
    if (ptAllStatus) {
      setPtFilters([]);
    }
  }, [ptAllStatus])

  const handlePrint = () => {
    const css = '@page { margin: 10px; size: A4 Portrait; transform: scale(0.8); transform-origin: top left }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  const handleChanges = (val) => {
    dispatch(getSaleOrderFormData(token, company_id, menuId, val, ""));
  };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const optimizedFn = useCallback(debounce(handleChanges), []);

  const onFinish = async (e) => {
    setSubmit(true);
    setLoading(true);
    await form.validateFields().then((values) => {
      let status = []
      allFilters.filter((item) => {
        if (item.selected === true) {
          status.push(item.id)
        }
        return item;
      });
      let ptStatus = []
      ptAllFilters.filter((item) => {
        if (item.selected === true) {
          ptStatus.push(item.id)
        }
        return item;
      });
      dispatch(getShippedStyleWisePercentageReport(token, values, status, ptStatus)).then((res) => {
        setData(res?.payload?.data);
        setLoading(false);
      });
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getStyle(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getInseam(token, menuId));
    dispatch(getCut(token, menuId))
  }, [dispatch, menuId, token]);



  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Shipped Style Wise Percentage",
    sheet: "Sheet 1",
  });

  const groupedData = data && data?.reduce((acc, item) => {
    const key = item.style_name + item.first_size;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {}) || {};

  const shipStyleWiseData = Object.values(groupedData);

  console.log("shipStyleWiseData", shipStyleWiseData)

 const parseQty = (val) => {
  if (val === undefined || val === null) return 0;
  return Number(String(val).replace(/,/g, '').trim()) || 0;
};

const sortedShipStyleWiseData = [...shipStyleWiseData].sort((groupA, groupB) => {
  const shippedA = groupA.find(item => item.row_type === "Shipped");
  const shippedB = groupB.find(item => item.row_type === "Shipped");

  const qtyA = parseQty(shippedA?.totalqty); // agar undefined bhi ho, to 0 treat hoga
  const qtyB = parseQty(shippedB?.totalqty);

  return qtyB - qtyA;
});

console.log("sortedShipStyleWiseData", sortedShipStyleWiseData)

  return (
    <>
      <div className="distributor header_class stock_style_wise">
        <div className="row justify-content-between shippedStyleWisePercentageTable">

          <div className="col-3 d-flex align-items-sm-center box-space">
            <div className="logobrand">
              <img id="ImgLogo" alt="logo" src={logo} />
            </div>
          </div>
          <div className="col-3 box-space right-content-header text-sm-right">
            <div className=" d-flex justify-content-end">
              <div className=" d-flex justify-content-end printing_class mr-8">
                <div className="print_icon printing_class">
                  {OmsReprot?.payload?.data.length ? (
                    <i
                      id="Image1"
                      title="Print"
                      alt="Print"
                      src={btnPrint}
                      className="fa-solid fa-print printing_class"
                    ></i>
                  ) : (
                    <i
                      id="Image1"
                      title="Print"
                      alt="Print"
                      src={btnPrint}
                      className="fa-solid fa-print printing_class"
                      onClick={handlePrint}
                    ></i>
                  )}
                </div>
                <div className="print_icon printing_class">
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    onClick={onDownloadReport}
                    // onClick={handleDownload}
                    style={{
                      borderWidth: "0px",
                      height: "14px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
              <span style={{ fontWeight: "bolder" }}>
                Shipped Style Wise Percentage
                <br />
                Rpt # 006
                <br />
                Login as:
                <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                  {" "}
                  {userName}
                </span>
              </span>
            </div>
          </div>

          {/* <div className="row printing_class">
                <div className="col text-sm-right pb-1"></div>
              </div> */}
          <>
            <div className="business_class_oms mb-2 distributor">
              <Form form={form} name="control-hooks" onFinish={onFinish}>
                <div className="main_form row">
                  <hr className="my-1" />
                  <div className="row">
                    <div className="checkboxes">
                      <label htmlFor="" style={{ marginRight: "15px" }}>Customer Type:</label>
                      <div className="checkbox_content">
                        <Form.Item name="pt_current_status_id" className=" mb-0">
                          <Checkbox
                            checked={ptAllStatus} onChange={statusPTSelectAll}
                          >
                            All
                          </Checkbox>
                        </Form.Item>
                      </div>
                      {ptAllFilters &&
                        ptAllFilters.map((it, index) => {
                          return (
                            <div key={index} className="checkbox_content">
                              <Form.Item name="pt_current_status_id">
                                <Checkbox
                                  checked={it.selected}
                                  onChange={(e) => {
                                    let copyArr = [...ptAllFilters];
                                    if (e.target.checked) {
                                      copyArr[index].selected = true;
                                    } else {
                                      copyArr[index].selected = false;
                                    }
                                    setPtAllFilters(copyArr);
                                    setPtAllStatus(false);
                                  }}
                                >
                                  {it.name}
                                </Checkbox>
                              </Form.Item>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <hr className="my-1" />
                  <div className="main_form row">
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">
                          From:
                        </label>
                        <div className="w-100">

                          <Form.Item
                            className="full_date"
                            name="from_date"
                            initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              className={"input-width"}
                              format={"MM-DD-YYYY"}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">To:</label>
                        <div className="w-100">
                          <Form.Item
                            className="full_date"
                            name="to_date"
                            initialValue={moment().endOf("year")}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              className={"input-width"}
                              format={"MM-DD-YYYY"}
                            />
                          </Form.Item>

                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">Sku</label>
                        <div className="w-100">
                          <Form.Item name="sku" className="sku_input">
                            <Input size="small" className={"select_Inputs mb-0"} />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width44">
                          Customer:
                        </label>
                        <div className="w-100">
                          <Form.Item name="customer" initialValue={"All"}>
                            <Select
                              notFoundContent={
                                saleOrderFormData.loading ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Loader
                                      type="Oval"
                                      color="#3c4b58"
                                      height={20}
                                      width={20}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      textAlign: "center",
                                    }}
                                  >
                                    No Data
                                  </div>
                                )
                              }
                              className={"select_Inputs"}
                              autoComplete={"nope"}
                              size="small"
                              showSearch
                              optionFilterProp="children"
                              loading={saleOrderFormData.loading}
                              defaultValue={form.getFieldValue().customer}
                              placeholder="Select Customer"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                            >
                              <Option value="All">All</Option>
                              {saleOrderFormData?.payload?.customerDetail.map(
                                (item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.customer_id}
                                      value={item.customer_id}
                                    >
                                      {" "}
                                      {`${item.customer_name}`}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_form row form-margin">
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">Region:</label>
                        <div className="w-100">
                          <Form.Item name="region" initialValue={"All"}>
                            <Select
                              className={"select_Inputs"}
                              showSearch
                              optionFilterProp="children"
                              size="small"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              filterSort={(optionA, optionB) =>
                                optionB?.value !== null ?
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                              }
                            >
                              <Option value={null}>All</Option>
                              {
                                region?.payload?.data.map((val) => {
                                  return (
                                    <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                                  )
                                })
                              }
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">Style</label>
                        <div className="w-100">
                          <Form.Item initialValue={"All"} name="style">
                            <Select
                              className={"select_Inputs"}
                              showSearch

                              optionFilterProp="children"
                              size="small"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              filterSort={(optionA, optionB) =>
                                optionB?.value !== null ?
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                              }
                            >
                              <Option value={null}>All</Option>
                              {style &&
                                style?.payload?.data.map((style, index) => {
                                  return (
                                    <Option key={index} value={style.style_id}>
                                      {style.style_name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">Category</label>
                        <div className="w-100">
                          <Form.Item initialValue={"All"} name="cut">
                            <Select
                              className={"select_Inputs"}
                              showSearch

                              optionFilterProp="children"
                              size="small"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              filterSort={(optionA, optionB) =>
                                optionB?.value !== null ?
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                              }
                            >
                              <Option value={null}>All</Option>
                              {cut &&
                                cut?.payload?.data?.map((status, index) => {
                                  return (
                                    <Option key={index} value={status.cut_id}>
                                      {status.cut_name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width44">Gender</label>
                        <div className="w-100">
                          <Form.Item initialValue={"All"} name="gender">
                            <Select
                              className={"select_Inputs"}
                              showSearch

                              optionFilterProp="children"
                              size="small"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              <Option value={null}>All</Option>
                              {gender &&
                                gender?.payload?.data.map((it, index) => {
                                  return (
                                    <Option key={index} value={it.gender_id}>
                                      {it.gender_name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>

                    </div>
                    <div className="main_form row form-margin" style={{ paddingRight: "0" }}>
                      <div className="col-12 col-md-3">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width44">Inseam</label>
                          <div className="w-100">
                            <Form.Item
                              name="inseam"
                              initialValue={"All"}
                            >
                              <Select
                                className={"select_Inputs"}
                                showSearch
                                optionFilterProp="children"
                                size="small"
                              >
                                <Option value={null}>All</Option>
                                {inseam?.payload?.data?.map((single) => {
                                  return (
                                    <Option
                                      value={`${single.inseam_name}`}
                                      key={single.inseam_id}
                                      label={single.inseam_name}
                                    >
                                      {single.inseam_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>

                      </div>
                      <div className="col-9" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "0" }} >
                        <div
                          className=" d-flex flex-row align-items-baseline"
                          style={{
                            justifyContent: "start",
                            marginTop: "3px",
                          }}
                        >
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="submit-btn-btm m-0"
                          >
                            Generate
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </>

          <div>
            <div className="business_class_oms" ref={tableRef} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {loading ? (
                <div className="loader" style={{ marginTop: "20px", textAlign: "center" }}>
                  <Spin size="large" />
                </div>
              ) : (
                sortedShipStyleWiseData.length > 0 ? (
                  sortedShipStyleWiseData.map((data, index) => {
                    const sizes = data;


                    let qty1 = null;
                    let qty2 = null;
                    let qty3 = null;
                    let qty4 = null;
                    let qty5 = null;
                    let qty6 = null;
                    let qty7 = null;
                    let qty8 = null;
                    let qty9 = null;
                    let qty10 = null;
                    let qty11 = null;
                    let qty12 = null;
                    let qty13 = null;
                    let qty14 = null;
                    let qty15 = null;
                    let qty16 = null;

                    for (let i = 0; i < data.length; i++) {
                      qty1 += parseInt(data[i].qty_1);
                      qty2 += parseInt(data[i].qty_2);
                      qty3 += parseInt(data[i].qty_3);
                      qty4 += parseInt(data[i].qty_4);
                      qty5 += parseInt(data[i].qty_5);
                      qty6 += parseInt(data[i].qty_6);
                      qty7 += parseInt(data[i].qty_7);
                      qty8 += parseInt(data[i].qty_8);
                      qty9 += parseInt(data[i].qty_9);
                      qty10 += parseInt(data[i].qty_10);
                      qty11 += parseInt(data[i].qty_11);
                      qty12 += parseInt(data[i].qty_12);
                      qty13 += parseInt(data[i].qty_13);
                      qty14 += parseInt(data[i].qty_14);
                      qty15 += parseInt(data[i].qty_15);
                      qty16 += parseInt(data[i].qty_16);
                    }

                    let sumQ = 0;

                    for (let i = 0; i < data.length; i++) {
                      sumQ += parseInt(data[i].sum_quantity);
                    }

                    return (
                      <div key={index}>
                        <div className="table_data-Heading shippedStyleWisePercentageTable ">
                          <h3>{data[0].style_name}</h3>
                        </div>
                        <table style={{ width: "100%" }} className="table_distributor-data shippedStyleWisePercentageTable ">
                          <tbody>
                            <tr style={{ lineHeight: "32px", backgroundColor: "#e0e6ed" }}>
                              <td className="font-weig">#</td>
                              <td className="font-weig" style={{ width: "100px", textAlign: "right", padding: "0px 2px" }} ></td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_1}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_2}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_3}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_4}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_5}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_6}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_7}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_8}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_9}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_10}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_11}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_12}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_13}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_14}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_15}
                              </td>
                              <td style={{ width: "60px", textAlign: "right", padding: "0px 2px" }} className="font-weig">
                                {sizes[0].size_16}
                              </td>
                              <td className="font-weig" style={{ textAlign: "right", width: "100px", padding: "0px 2px" }} >Quantity</td>
                            </tr>
                            {data.map((values, index) => {
                              return (
                                <tr key={index}>
                                  <td style={{ width: "40px" }}>{index + 1}</td>
                                  {/* <td style={{ width: "100px" }}>
                                    {values.row_type === "Production" ? (
                                      <Link
                                        to="/production-sku-wise-percentage"
                                        state={{ data: values }}
                                        style={{ color: "blue", textDecoration: "underline" }}
                                      >
                                        Production
                                      </Link>
                                    ) : (
                                      values.row_type
                                    )}
                                  </td> */}
                                  <td style={{ width: "100px" }}>
                                    {values.row_type === "Production" ? (
                                      <a
                                        href={`/production-sku-wise-percentage?${new URLSearchParams({
                                          style: values.styl_id,
                                          from_date: form.getFieldValue("from_date")?.format("MM-DD-YYYY"),
                                          to_date: form.getFieldValue("to_date")?.format("MM-DD-YYYY"),
                                        }).toString()}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                      >
                                        Production
                                      </a>
                                    ) : (
                                      values.row_type
                                    )}
                                  </td>
                                  {values.qty_1 && (
                                    <td key={index} style={{ textAlign: "right", padding: "2px" }} >{numeral(values.qty_1).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  )}
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_2).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_3).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_4).format('0,0')}{(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_5).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_6).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_7).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_8).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_9).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_10).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_11).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_12).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_13).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_14).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_15).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", padding: "2px" }}>{numeral(values.qty_16).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                  <td style={{ textAlign: "right", paddingRight: "2px", width: "40px" }}>{numeral(values.totalqty).format('0,0')} {(values.row_type === "Shipped%" || values.row_type === "Production%" || values.row_type === "OTS%") ? "%" : ""}</td>
                                </tr>
                              );
                            })}


                          </tbody>
                        </table>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-Data" style={{ width: '65%' }}>
                    <h1>No Data</h1>
                  </div>
                )
              )}
              { }
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ShippedStyleWisePercentage2;
